"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpLeftNavigation = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var Icon_1 = require("../Icon/Icon");
var react_i18next_1 = require("react-i18next");
// import { useRouter } from 'next/router';
var accessibility_helper_1 = require("../../../api/helpers/accessibility.helper");
var DpLeftNavigation_styled_1 = require("./DpLeftNavigation.styled");
var router_1 = require("next/router");
var link_1 = __importDefault(require("next/link"));
var NavElement = function (_a) {
    var _b = _a.leftNavElement, icon = _b.icon, text = _b.text, showText = _a.showText;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "nav-element", children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: icon }), showText && (0, jsx_runtime_1.jsx)("span", { children: text })] }));
};
/**
 * DpLeftNavigation
 * @property {Array}       elements        - List of icons to show
 * @property {boolean}     collapsed       - Indicates if the menu is collapsed
 *
 */
exports.DpLeftNavigation = (0, react_1.memo)(function (_a) {
    var _b;
    var _c = _a.elements, elements = _c === void 0 ? [] : _c, _d = _a.collapsed, collapsed = _d === void 0 ? true : _d, outSideClick = _a.outSideClick;
    // ----------- State
    var _e = (0, react_1.useState)((_b = elements[0]) === null || _b === void 0 ? void 0 : _b.id), activeElement = _e[0], setActiveElement = _e[1];
    var router = (0, router_1.useRouter)();
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var ulRef = (0, react_1.useRef)(null);
    var selectOption = (0, react_1.useCallback)(function (key) {
        setActiveElement(key);
    }, []);
    var handleOutsideClick = (0, react_1.useCallback)(function (e) {
        if (!e.target.classList.contains('hamburger-or-x-icon') &&
            ulRef.current &&
            !ulRef.current.contains(e.target)) {
            outSideClick && outSideClick();
        }
    }, [ulRef, outSideClick]);
    (0, react_1.useEffect)(function () {
        if (!collapsed) {
            document.addEventListener('click', handleOutsideClick);
        }
        return function () {
            document.removeEventListener('click', handleOutsideClick);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [collapsed]);
    return ((0, jsx_runtime_1.jsx)(DpLeftNavigation_styled_1.StyledNavBar, { onSelect: selectOption, className: "left-nav flex-column bg-white", collapsed: collapsed ? 1 : 0, role: "navigation", "data-testid": "dp-left-navigation", children: (0, jsx_runtime_1.jsx)("ul", { ref: ulRef, children: elements.map(function (element) {
                var _a, _b;
                return ((0, jsx_runtime_1.jsx)("li", { children: collapsed ? ((0, jsx_runtime_1.jsx)(react_bootstrap_1.OverlayTrigger
                    // @ts-ignore
                    , { trigger: ['focus', 'hover'], overlay: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Tooltip, { id: element.id, placement: "right", children: element.text }), children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Nav.Link, { eventKey: element.id, as: link_1.default, href: element.url, prefetch: false, legacyBehavior: false, active: !!((_a = element.supportedUrls) === null || _a === void 0 ? void 0 : _a.find(function (url) { return router.pathname.includes(url); })), "aria-label": t("leftNavigation.navigationAriaLabel", {
                                selected: "".concat(activeElement === element.id
                                    ? t('leftNavigation.selected')
                                    : t('leftNavigation.notSelected')),
                                optionName: "".concat(element.alternativeText),
                            }), onKeyDown: (0, accessibility_helper_1.handleButtonPress)(function () {
                                router.push("".concat(element.url, "?focus=true"));
                            }), "data-testid": element.id, children: (0, jsx_runtime_1.jsx)(NavElement, { leftNavElement: element, showText: false }) }, "nav-link-".concat(element.url)) }, "tooltip-".concat(element.id))) : ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Nav.Link, { eventKey: element.id, as: link_1.default, legacyBehavior: false, href: element.url, prefetch: false, active: !!((_b = element.supportedUrls) === null || _b === void 0 ? void 0 : _b.find(function (url) { return router.pathname.includes(url); })), "aria-label": t("leftNavigation.navigationAriaLabel", {
                            selected: "".concat(activeElement === element.id
                                ? t('leftNavigation.selected')
                                : t('leftNavigation.notSelected')),
                            optionName: "".concat(element.alternativeText),
                        }), onKeyDown: (0, accessibility_helper_1.handleButtonPress)(function () {
                            router.push("".concat(element.url, "?focus=true"));
                        }), children: (0, jsx_runtime_1.jsx)(NavElement, { leftNavElement: element, showText: true }) }, "nav-link-".concat(element.url))) }, element.id));
            }) }) }));
});
exports.default = exports.DpLeftNavigation;
